module.exports = __webpack_public_path__ + "static/media/gc_graphic.526f684f.gif";